// extracted by mini-css-extract-plugin
export default {"callout":"Callout_callout__PHNYX","info":"Callout_info__b0T+v","label":"Callout_label__KJGWl","body":"Callout_body__QYZc-"};